import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";
import "./style.css";
import { useDispatch, useSelector } from "react-redux";
import { SigninAction } from "../../../commons/redux/actions/auth.action";
import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  useDisclosure,
  useToast
} from "@chakra-ui/react";

export default function Signin() {
  const toast = useToast();
  const [see, setSee] = useState("password");
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { user } = useSelector(state => state.userReducer);
  const { message } = useSelector(state => state.authReducer);
  const [load, setLoad] = useState();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  useEffect(
    () => {
      if (typeof window !== "undefined" && user) {
        toast({
          title: "Connecte.",
          description: "Connexion reussie !.",
          status: "success",
          duration: 9000,
          isClosable: true
        });
        window.location.href = "/";
      }
    },
    [user, navigate, toast]
  );
  function signin(values) {
    try {
      setLoad("true");
      console.log(load);
      const { token, user } = dispatch(SigninAction(values));

      if (token || user) {
        return;
      }
    } catch (err) {
      setLoad(false);
    }
  }
  const formik = useFormik({
    initialValues: {
      password: "",
      email: ""
    },
    onSubmit: values => {
      setLoad(true);
      signin(values);
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .email("Mettez un email valide")
        .lowercase()
        .required("Ce champ est requis"),
      password: Yup.string()
        .required("Ce champ est requis !")
        .min(4, "Il faut au moins 4 caracteres")
    })
  });

  const change = () => {
    if (see === "password") {
      setSee("text");
    } else {
      setSee("password");
    }
  };

  return (
    <div>
      <div className="container flex-col">
        <div className="form mx-auto p-2 text-center text-muted my-2">
          <h2 className="text-xs">havoo</h2>
          <div className="title_sign">
            <h3>Se connecter</h3>
            <p className="text-muted text-sm">
              Veuillez remplir le formulaire suivant pour vous connecter et
              continuer a profiter de nos fonctionnalites
            </p>
          </div>
          {message
            ? <div
                class="bg-red-100 my-2 border-l-8 border-red-400 text-red-700 px-4 py-3 rounded relative"
                role="alert"
              >
                <span class="block font-bold sm:inline">
                  {message}
                </span>
                <span
                  onClick={() => {
                    dispatch({
                      type: "REMOVE_ERR",
                      payload: ""
                    });
                  }}
                  class="absolute top-0 bottom-0 right-0 px-4 py-3"
                >
                  <svg
                    class="fill-current h-6 w-6 text-red-500"
                    role="button"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                  >
                    <title>Close</title>
                    <path d="M14.348 14.849a1.2 1.2 0 0 1-1.697 0L10 11.819l-2.651 3.029a1.2 1.2 0 1 1-1.697-1.697l2.758-3.15-2.759-3.152a1.2 1.2 0 1 1 1.697-1.697L10 8.183l2.651-3.031a1.2 1.2 0 1 1 1.697 1.697l-2.758 3.152 2.758 3.15a1.2 1.2 0 0 1 0 1.698z" />
                  </svg>
                </span>
              </div>
            : ""}
          <form autoComplete={false} className="">
            <div className="form-group">
              <label htmlFor="" className="sr-only">
                Email
              </label>
              <input
                type="email"
                name="email"
                placeholder="Email"
                className="appearance-none form-control border-2 border-gray-200 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white"
                value={formik.values.email}
                onChange={formik.handleChange}
                error={formik.touched.email && Boolean(formik.errors.email)}
              />
              <small className="helper-text form-tex text-red-500">
                {formik.touched.email && formik.errors.email}
              </small>
            </div>

            <div className="form-group position-relative mt-3">
              <label htmlFor="" className="sr-only">
                Mot de passe
              </label>
              <input
                type={`${see}`}
                name="password"
                placeholder="Mot de passe"
                className="appearance-none form-control border-2 border-gray-200 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white"
                value={formik.values.password}
                onChange={formik.handleChange}
                error={
                  formik.touched.password && Boolean(formik.errors.password)
                }
              />
              <button
                type="button"
                onClick={change}
                className="btn focus:outline-none focus:bg-black focus:text-white btn-sm  bg-gray-100 rounded font-semibold  position-absolute top-1 right-0  "
              >
                {see === "password" ? "Voir" : "Cacher"}
              </button>
              <small className="helper-text form-tex text-red-500">
                {formik.touched.password && formik.errors.password}
              </small>
            </div>
            <p
              onClick={onOpen}
              className="hover:text-red-400 hover:cursor-pointer text-sm my-2 text-muted float-right"
            >
              Mot de passe oublié ?
            </p>
            <div className="flex-col">
              {load
                ? <Button
                    isLoading={true}
                    loadingText="Connexion..."
                    variant={"solid"}
                    colorScheme={"orange"}
                    className="btn btn-block w-100  bg-gray-300 my-2 font-bold text-xl"
                  />
                : <Button
                    type="button"
                    variant={"solid"}
                    colorScheme={"orange"}
                    onClick={formik.handleSubmit}
                    className="btn btn-block w-100  bg-gray-300 my-2 font-bold text-xl"
                  >
                    Connexion
                  </Button>}
            </div>
          </form>
          <div className="mx-auto text-center flex flex-wrap mt-2 justify-content-center">
            <p className="text-md text-muted">
              Si vous n'etes pas encore inscrit vous pouvez {" "}
            </p>
            <a
              href="/inscription"
              className=" border p-1 mt-2 bg-gray-100 rounded text-red text-sm"
            >
              Creer un compte
            </a>
          </div>
        </div>
      </div>

      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader className="text-center text-2xl text-gray">
            <h3 className="opacity-30">Configurer email</h3>
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <form className="w-full max-w-sm" autoComplete={false}>
              <div class="md:flex md:items-center mb-6">
                <div class="md:w-1/3">
                  <label
                    class="block text-gray-500 font-bold md:text-right mb-1 md:mb-0 pr-4"
                    for="inline-full-namea"
                  >
                    Votre email{" "}
                  </label>
                </div>
                <div class="md:w-2/3">
                  <input
                    className="appearance-none form-control border-2 border-gray-200 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white"
                    id="inline-full-name"
                    type="text"
                    name="name"
                  />
                </div>
              </div>

              <div class="md:flex md:items-center">
                <div class="md:w-1/3" />
                <div class="md:w-2/3">
                  {load
                    ? <Button
                        isLoading={"true"}
                        colorScheme={"facebook"}
                        variant={"outline"}
                        loadingText={"Patientez..."}
                        type="button"
                      />
                    : <Button
                        variant={"solid"}
                        colorScheme={"facebook"}
                        className=" btn bg-red-500 text-white hover:bg-red-800 hover:text-white focus:shadow-outline focus:outline-none font-bold py-2 px-4 btn-block w-full rounded"
                        type="button"
                      >
                        Envoyer le lien{" "}
                      </Button>}
                </div>
              </div>
            </form>
          </ModalBody>
        </ModalContent>
      </Modal>
    </div>
  );
}
